var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.495 12.4997C20.495 13.1147 20.038 13.6133 19.4742 13.6133H4.9916L10.4672 19.5867C10.8658 20.0216 10.8658 20.7267 10.4672 21.1616C10.0685 21.5964 9.42218 21.5964 9.02353 21.1616L1.80534 13.2872C1.40669 12.8523 1.40669 12.1472 1.80534 11.7123L9.02353 3.83789C9.42218 3.403 10.0685 3.403 10.4672 3.83789C10.8658 4.27278 10.8658 4.97788 10.4672 5.41277L4.9916 11.3861H19.4742C20.038 11.3861 20.495 11.8847 20.495 12.4997Z",
    fill: "#071437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.43d010faaa5c71d0dffc3386c8a6aa96.svg";
export { ForwardRef as ReactComponent };